import React, { PropsWithChildren } from 'react';
import { useIsMobile } from '../../../hook/common/useIsMobile/useIsMobile.hook';
import WrapperDesktopView from './Wrapper.view.desktop';
import WrapperMobileView from './Wrapper.view.mobile';

export default function WrapperView(
  props: PropsWithChildren<Record<string, unknown>>,
) {
  const isMobile = useIsMobile();
  const { children } = props;
  return isMobile ? (
    <WrapperMobileView>{children}</WrapperMobileView>
  ) : (
    <WrapperDesktopView>{children}</WrapperDesktopView>
  );
}
